import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as AccountIcon } from '../../assets/icons/account.svg';

interface Props {
  email: string;
  onLogout: () => void;
}

const UserMenu = ({ email, onLogout }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleOutsideClick = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  const handleLogout = () => {
    setIsOpen(false);
    onLogout();
  };

  return (
    <div className='user-menu' ref={containerRef}>
      <button
        type='button'
        className='user-menu__trigger'
        aria-haspopup='menu'
        aria-expanded={isOpen}
        aria-label={email}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <AccountIcon className='account-icon' />
      </button>
      {isOpen && (
        <ul className='user-menu__dropdown' role='menu'>
          <li className='user-menu__email'>{email}</li>
          <li>
            <button type='button' role='menuitem' className='user-menu__option' onClick={handleLogout}>
              <FormattedMessage id='ec.components.buttons.logout' defaultMessage='Abmelden' />
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default UserMenu;
